<tui-textfield multi tuiChevron [stringify]="stringify" [tuiTextfieldSize]="size" [tuiSkeleton]="loading" [rows]="rows">
  <label tuiLabel>
    {{ 'field.jobTitle' | customNames }}
    <span *ngIf="required" class="tui-required"></span>
  </label>
  <input tuiInputChip tuiSelectLike [(ngModel)]="value" [invalid]="invalid && touched" />

  <ng-container *ngIf="showAsChips">
    <tui-input-chip *tuiItem />
  </ng-container>

  <ng-container *tuiTextfieldDropdown>
    <app-search class="search" (searchQueryChange)="search$.next($event)"></app-search>

    <tui-data-list>
      <tui-opt-group tuiMultiSelectGroup [label]="'field.jobTitle' | customNames">
        <button *ngFor="let job of filteredJobTitles$ | async" new tuiOption [value]="job.jobTitleId">
          {{ job.jobTitleName }}
        </button>
      </tui-opt-group>
    </tui-data-list>
  </ng-container>
</tui-textfield>
